import { executeGet, executePost } from '../http-utils';

export const endpointUrl = '/api/managedReview/';

export const get = (authToken: string) => executeGet<models.CustomerManagedReviewModel>(endpointUrl + 'get/?authToken=' + (authToken ? encodeURIComponent(authToken) : ''));
export const review = (model: models.CustomerManagedReviewModel) => executePost<models.DefaultCommandResult>(endpointUrl + 'review/', model);
